import {menuToggle} from './components/menu';
import {modal} from './components/modal';
import {contactForm} from './components/contact-form';

menuToggle();
modal('js-open-modal');
contactForm('contact-form', 'contact-form-submit');
